import React, { useState, useEffect } from 'react';
import Header from './includes/header';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import Footer from './includes/footer';
import Courses from './components/courses';
import Course from './components/course';
import Register from './components/register';
import Contact from './components/contact';
import Payment from './components/payment';
import ConfirmPay from './components/confirmpay';
import AIAgent from './components/AIAgent';
import TalentMarketplace from './components/talentmarketplace';
import GraduateProfile from './components/graduateprofile';
import CompanyRegister from './components/companyregister';
import TalentPayment from './components/talentpayment';
import CompanyDashboard from './components/companydashboard';
import TalentProgram from './components/talentprogram';

// import InstallPrompt from './components/InstallPrompt';
import './assets/vendors/bootstrap/bootstrap.css';
import './assets/vendors/awesome/css/fontawesome-all.min.css';
import './assets/vendors/flaticon/flaticon.css';
import './assets/vendors/magnific-popup/magnific-popup.css';
import './assets/vendors/animate-css/animate.css';
import './assets/vendors/animated-headline/animated-headline.css';
import './assets/vendors/owl/assets/owl.carousel.min.css';
import './assets/vendors/owl/assets/owl.theme.default.min.css';
import './assets/css/woocomerce.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './styles/ath-buttons.css';
import './assets/js/script.js';
import ScrollToTop from './components/ScrollToTop';

function App() {
    const [showAIAgent, setShowAIAgent] = useState(false);

    useEffect(() => {
        const hasShown = sessionStorage.getItem('aiAgentShown');
        const isHome = window.location.pathname === '/' || window.location.pathname === '/home';

        if (!hasShown && isHome) {
            const timer = setTimeout(() => {
                sessionStorage.setItem('aiAgentShown', 'true');
                setShowAIAgent(true);
            }, 8000);
            return () => clearTimeout(timer);
        }
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <div className="ai-agent-trigger">
                <button onClick={() => setShowAIAgent(true)} className="ai-agent-btn btn-ath-purple" aria-label="Open Zuriel course advisor">
                    <i className="fas fa-robot"></i> Ask Zuriel
                </button>
            </div>
            {showAIAgent && <AIAgent onClose={() => setShowAIAgent(false)} />}
            <Routes>
                <Route path='/' element={<><Header /><Home />  <Footer /></>} />
                <Route path='/home' element={<><Header /><Home />   <Footer /></>} />
                <Route path='/courses' element={<><Header /><Courses />   <Footer /></>} />
                <Route path='/talent-marketplace' element={<><Header /><TalentMarketplace />  <Footer /></>} />
                <Route path='/graduates' element={<><Header /><TalentMarketplace />  <Footer /></>} />
                <Route path='/graduates/:slug' element={<><Header /><GraduateProfile />  <Footer /></>} />
                <Route path='/talent-program' element={<><Header /><TalentProgram />  <Footer /></>} />
                <Route path='/company-register' element={<><Header /><CompanyRegister />  <Footer /></>} />
                <Route path='/talent-payment' element={<><Header /><TalentPayment />  <Footer /></>} />
                <Route path='/company-dashboard' element={<><Header /><CompanyDashboard />  <Footer /></>} />
                <Route path='/*' element={<div>Not Found</div>} />
                <Route path='/register' element={<><Header /><Register />  <Footer /></>} />
                <Route path='/courses/:courseSlug' element={<><Header /><Course />  <Footer /></>} />
                <Route path='/contact' element={<><Header /><Contact />  <Footer /></>} />
                <Route path='/pay' element={<><Payment />  </>} />
                <Route path='/confirm' element={<><ConfirmPay />  </>} />
            </Routes>
        </Router>
    );
}

export default App;